/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Grid, TextField } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { AllAdjustmentGrid } from './TableHead';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getAllAdjustmentGrid,
  getAdjustmentReasonCodeResultGrid,
  setAdjustmentReasonCodeGrid,
} from '../Store/actions';
import {
  ADJUSTMENT_REQUIRED,
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  INVALID_DATE_DURATION,
  REBATE_SELECT,
  TO_DATE_GREATER_THAN_FROM,
  NO_DATA,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  autoFormateDate,
  tabHighLigther,
  validateDate,
} from '../../../../SharedModules/utilities/utilities';
import {
  validateDateQuarter,
  compareDate,
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqAdjustmentReasonCode(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    isAllAdjustmentSelected: isAllAdjustmentSelectedValue,
    scrollDownManufacturers: scrollDownManufacturersValue,
    fromDateValue,
    toDateValue,
    allAdjustmentGrid,
    searchResult,
    selectedRowIndexValue,
  } = useSelector((state) => state?.sharedState?.AdjustmentReasonCodeReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );

  const [errorList, setErrorList] = React.useState(errors);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);
  const [isAllAdjustmentSelected, setIsAllAdjustmentSelected] = React.useState(
    isAllAdjustmentSelectedValue
  );
  const [allAdjustmentList, setAllAdjustmentList] = React.useState([]);
  const [allAdjustmentSelected, setAllAdjustmentSelected] =
    React.useState('ALL');
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = React.useState(
    selectedRowIndexValue
  );
  const [scrollDownManufacturers, setScrollDownManufacturers] = React.useState(
    scrollDownManufacturersValue
  );
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/adjustmentByReasonCode', true);
    } else {
      tabHighLigther('/adjustmentByReasonCode', false);
    }
  }, [JSON.stringify(errorList)]);

  // function to validate from Date and toDate on onblur
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let allErrors = [];
    let fromError = [];
    let toError = [];
    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      fromError = validateDateQuarter(value, 'fromDate');
    }
    if (type === 'toDate') {
      setToDate(value.toUpperCase());
      if (value != '') {
        toError = validateDateQuarter(value, 'toDate');
      }
    }
    if (type === 'fromDate' && !fromError.length && !toDate) setToDate(value);
    if (fromError.length === 0 && toError.length === 0) {
      if (toDate.length > 0 && compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      } else {
        let fromDateValue = fromDate;
        let toDateValue = toDate;
        if (fromDateValue.includes('Q')) {
          fromDateValue = convertStringDate(
            quarterToDate(fromDateValue, 'fromDate')
          );
        }
        if (toDateValue?.includes('Q')) {
          toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
        }
        if (toDateValue.length === 0) {
          toDateValue = fromDateValue;
        }
        if (moment(toDateValue).diff(moment(fromDateValue), 'years') > 0) {
          allErrors.push({
            field: 'fromDate>toDate',
            message: INVALID_DATE_DURATION,
          });
        }
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];
    setErrorList(allErrors);
  };

  // To set manufacturer Id and Name and remove the error msg
  const onSelectionChanged = (e) => {
    e.api.clearFocusedCell(); 
    const errors = errorList.filter((error) => error.field !== 'allAdjustment');
    setErrorList([...errors]);
    const selectedRows = e.api.getSelectedRows();
    const selectedCodeValues = selectedRows.map((item) => item.codeValue);
    let selected = e.api.getSelectedNodes();
    const indexes = selected.map((o) => o.rowIndex);
    // allAdjustmentList.forEach((item, index) => {
    //   if (selectedCodeValues.indexOf(item.codeValue) !== -1) {
    //     indexes.push(index);
    //   }
    // });
    setSelectedRowIndex(indexes);
    setAllAdjustmentSelected(selectedRows);
  };

  // Calling API to get the GRid
  React.useEffect(() => {
    dispatch(getAllAdjustmentGrid([]));
  }, []);

  React.useEffect(() => {
    setAllAdjustmentList(allAdjustmentGrid?.adjustmentByReasonCodeGridVO);
  }, [allAdjustmentGrid]);

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = ''
  ) => {
    let allErrors = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    const fromError = validateDateQuarter(fromDate, 'fromDate');
    let toError = [];
    if (toDate.length > 0) {
      toError = validateDateQuarter(toDate, 'toDate');
    }
    if (fromError.length === 0 && toError.length === 0) {
      if (toDate.length > 0 && compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      } else {
        let fromDateValue = fromDate;
        let toDateValue = toDate;
        if (fromDateValue.includes('Q')) {
          fromDateValue = convertStringDate(
            quarterToDate(fromDateValue, 'fromDate')
          );
        }
        if (toDateValue?.includes('Q')) {
          toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
        }
        if (toDateValue.length === 0) {
          toDateValue = fromDateValue;
        }
        if (moment(toDateValue).diff(moment(fromDateValue), 'years') > 0) {
          allErrors.push({
            field: 'fromDate>toDate',
            message: INVALID_DATE_DURATION,
          });
        }
      }
    }
    const adjustmentSelected =
      allAdjustmentSelected === 'ALL'
        ? allAdjustmentList
        : allAdjustmentSelected;

    if (
        !onDoubleClick &&
        isAllAdjustmentSelected &&
        (!allAdjustmentList || allAdjustmentList.length === 0)
      ) {
        allErrors.push({
          field: 'noData',
          message: NO_DATA,
        });
      }

    if (
      !onDoubleClick &&
      !isAllAdjustmentSelected &&
      adjustmentSelected.length === 0
    ) {
      allErrors.push({
        field: 'allAdjustment',
        message: ADJUSTMENT_REQUIRED,
      });
    }
    if (onDoubleClick && selectedRowOnDoubleClick === '') {
      allErrors.push({
        field: 'allAdjustment',
        message: ADJUSTMENT_REQUIRED,
      });
    }

    allErrors = [...allErrors, ...fromError, ...toError];

    setErrorList(allErrors);

    let tempIndexes = [];
    if (onDoubleClick) {
      allAdjustmentGrid.adjustmentByReasonCodeGridVO.forEach((item, index) => {
        if (
          selectedRowOnDoubleClick &&
          selectedRowOnDoubleClick?.codeValue === item.codeValue
        ) {
          tempIndexes = [index];
        }
      });
    }
      if (Array.isArray(adjustmentSelected) && adjustmentSelected.length > 0) {
        adjustmentSelected.sort((a, b) =>
          a.codeValue > b.codeValue ? 1 : a.codeValue < b.codeValue ? -1 : 0
        );
      }
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        fromDateValue: fromDate,
        toDateValue: toDate,
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramNameValue: rebateProgramName,
        rebateProgrameName,
        isAllAdjustmentSelected,
        scrollDownManufacturers,
        selectedRowIndexValue: onDoubleClick ? tempIndexes : selectedRowIndex,
        adjustmentSelected: onDoubleClick
          ? [selectedRowOnDoubleClick]
          : adjustmentSelected,
        dispalyObj: {
          rebateProgrameName,
          rebateProgramValue: rebateProgram,
          fromDateValue: fromDate,
          toDateValue: toDate,
          adjustmentSelected: onDoubleClick
            ? [selectedRowOnDoubleClick]
            : adjustmentSelected,
          selectedPlanType: planType,
          rebateProgramList: rebateProgramListData,
        },
      })
    );

    if (allErrors.length === 0) {
      dispatch(setAdjustmentReasonCodeGrid([]));
      setSearchClicked(true);
      // if (!isAllAdjustmentSelected) {
      const drugActivityTypeSelected = [];
      if (
        adjustmentSelected[0]?.codeValue === 'R' ||
        selectedRowOnDoubleClick?.codeValue === 'R'
      ) {
        drugActivityTypeSelected.push('URAC', 'URCA', 'URAL');
      }
      if (
        adjustmentSelected[0]?.codeValue === 'W' ||
        selectedRowOnDoubleClick?.codeValue === 'W'
      ) {
        drugActivityTypeSelected.push('WOFF', 'DBAL', 'FRGV');
      }
      if (
        adjustmentSelected[0]?.codeValue === 'I' ||
        selectedRowOnDoubleClick?.codeValue === 'I'
      ) {
        drugActivityTypeSelected.push('IOAR', 'IDBL');
      }
      if (
        adjustmentSelected[0]?.codeValue === 'X' ||
        selectedRowOnDoubleClick?.codeValue === 'X'
      ) {
        drugActivityTypeSelected.push('ICLC', 'IDBU');
      }
      if (
        adjustmentSelected[0]?.codeValue === 'U' ||
        selectedRowOnDoubleClick?.codeValue === 'U'
      ) {
        drugActivityTypeSelected.push(
          'UACD',
          'UACM',
          'UAAR',
          'UCCN',
          'UOCR',
          'UOMR'
        );
      }
      if (
        adjustmentSelected[0]?.codeValue === 'T' ||
        selectedRowOnDoubleClick?.codeValue === 'T'
      ) {
        drugActivityTypeSelected.push('DBUP');
      }
      const adjustmentSelectedData = onDoubleClick
        ? [selectedRowOnDoubleClick]
        : adjustmentSelected;
      if (adjustmentSelectedData.length === 1) {
        let fromDateValue = fromDate;
        let toDateValue = toDate;
        if (fromDateValue.includes('Q')) {
          fromDateValue = convertStringDate(
            quarterToDate(fromDateValue, 'fromDate')
          );
        }
        if (toDateValue?.includes('Q')) {
          toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
        }
        if (toDateValue.length === 0) {
          toDateValue = fromDateValue;
        }
        dispatch(
          getAdjustmentReasonCodeResultGrid({
            rebateProgramCd: rebateProgram,
            beginDate: fromDateValue,
            endDate: toDateValue,
            drugActivityTypeCd: drugActivityTypeSelected,
            mfgTypeCd: planType === 'FD' || planType === 'ST' ? 'G' : 'C',
          })
        );
      } else {
        redirectURLLink(
          '/dispAdjustmentByReasonCode',
          'Display Adjustment By Reason Code',
          props.history
        );
      }
      // }
    }
    dispatch(clearReduxForFilterAndSort('/dispAdjustmentByReasonCode'));
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */

    if (allErrors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
    if (isSearchClicked && errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errors]);
    
    //remove no data error msg 
    React.useEffect(() => {
      dispatch(setSearchInput({ errors: [] }));
    }, [planType, rebateProgram, spinnerLoader, fullScreenView, fromDate, toDate, scrollDownManufacturers, isAllAdjustmentSelected ]);

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/dispAdjustmentByReasonCode',

      value: 'Display Adjustment By Reason Code',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    props.history.push({
      pathname: '/dispAdjustmentByReasonCode',
    });
    dispatch(clearReduxForFilterAndSort('/dispAdjustmentByReasonCode'));
  }

  const cellClickedListener = (e) => {
    setAllAdjustmentSelected(e?.data);
    // setManufacturerSelectedId(e?.data);
    handleSearchClick(null, true, e?.data);
  };

  const updatedErrorList = errorList.map((item) => {
    return {
      ...item,
      message: item.message
        .replace('From date', 'Begin date')
        .replace('To date', 'End date')
        .replace('Start Date', 'Begin Date'),
    };
  });
  const errorMessages = [
    ...new Set(updatedErrorList.map((obj) => obj.message)),
  ];

  // const errorMessages = [...new Set(errorList.map((obj) => obj.message))];

  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      {/* <Spinner load={isLoading} /> */}
      <CustomSeparator
        parent1="State Reports"
        parent2="Adjustment By Reason Code"
      />
      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="fltr-plan-type"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <>
                  <Fieldset label="Rebate Program" required>
                    <div>
                      <SelectBoxComponent
                        data-testid="fltr-Rbt-prm"
                        id="filter-plan-by-radio-btn-action"
                        labelName="Rebate Program"
                        required
                        select
                        selectOne
                        optionList={selectList || []}
                        defaultValue={rebateProgram}
                        filterAction={(value) => {
                          setRebateProgram(value);
                          setRebateProgramName(value);
                          const errors = errorList.filter(
                            (error) => error.field !== 'rebateProgram'
                          );
                          setErrorList([...errors]);
                        }}
                        isError={
                          errorList.find(
                            (error) => error.field === 'rebateProgram'
                          )?.message
                        }
                      />
                    </div>
                  </Fieldset>
                </>
              </div>
              <div className="col-4">
                <Fieldset label="Date/Quarter Range">
                  <div className="form-wrapper p-0 mt-n3">
                    <div className="mui-custom-form input-md field-xl">
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Begin Date"
                            id="From Date"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              maxLength: 10,
                              'aria-describedby': '',
                            }}
                            required
                            name="From"
                            value={fromDate}
                            error={
                              updatedErrorList.filter(
                                (error) => error.field === 'fromDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            data-testid="interest-Recieved-from-date"
                            helperText={
                              updatedErrorList.find(
                                (error) => error.field === 'fromDate'
                              )?.message
                            }
                            className="mandate-fields"
                            onBlur={(e) =>
                              handleOnBlur('fromDate', e.target.value)
                            }
                            onChange={(e) => {
                              setFromDate(e.target.value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) => error.field !== 'fromDate'
                                ),
                              ]);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="End Date"
                            id="To Date"
                            data-testid="interest-Recieved-to-date"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            // required={true}
                            inputProps={{ maxLength: 10 }}
                            name="to"
                            value={toDate}
                            onBlur={(e) =>
                              handleOnBlur('toDate', e.target.value)
                            }
                            onChange={(e) => {
                              setToDate(e.target.value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) =>
                                    error.field !== 'toDate' &&
                                    error.field !== 'fromDate>toDate'
                                ),
                              ]);
                            }}
                            error={
                              updatedErrorList.filter(
                                (error) =>
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            helperText={
                              updatedErrorList.find(
                                (error) =>
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.message
                            }
                            className="mandate-fields"
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Fieldset>
                {/* <Fieldset label={'Date Range'}>
                  <div className="form-wrapper p-0 mt-n3">
                    <div className="mui-custom-form input-md field-xl">
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Begin Date"
                            id="fromdate"
                            data-testid="req-adj-rea-from"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 10, id: 'fromdate' }}
                            required
                            name='From'
                            value={fromDate}
                            error={
                              errorList.filter(
                                (error) =>
                                  error.field === 'fromDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            className='mandate-fields'
                            onBlur={(e) =>
                              handleOnBlur('fromDate', e.target.value)
                            }
                            onChange={(e) => {
                              let value = e.target.value;

                              setFromDate(value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) =>
                                    error.field !== 'fromDate' &&
                                    error.field !== 'fromDate>toDate'
                                ),
                              ]);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="End Date"
                            id="toDate"
                            data-testid="req-adj-rea-to"
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            // required={true}
                            inputProps={{ maxLength: 10, id: 'toDate' }}
                            name="to"
                            value={toDate}
                            onBlur={(e) =>
                              handleOnBlur('toDate', e.target.value)
                            }
                            onChange={(e) => {
                              setToDate(e.target.value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) =>
                                    error.field !== 'toDate' &&
                                    error.field !== 'fromDate>toDate'
                                ),
                              ]);
                            }}
                            error={
                              errorList.filter(
                                (error) =>
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            className='mandate-fields'
                          />
                        </Grid>
                        <Grid xs={12} md={12}>
                          <div
                            className='MuiFormHelperText-root Mui-error Mui-required'
                            style={{
                              padding: '0px 10px',
                              fontSize: 12,
                              fontWeight: 600,
                            }}
                          >
                            {
                              errorList.find(
                                (error) =>
                                  error.field === 'fromDate' ||
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.message
                            }
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Fieldset> */}
              </div>
            </div>
            <div className="row ml-3 mt-4">
              <div className="col-4">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isAllAdjustmentSelected}
                      color="primary"
                      name="allManufacturers"
                      onChange={async (e) => {
                        setIsAllAdjustmentSelected(!isAllAdjustmentSelected);
                        setScrollDownManufacturers(!scrollDownManufacturers);
                        if (!isAllAdjustmentSelected) {
                          setAllAdjustmentSelected('ALL');
                        } else {
                          setAllAdjustmentSelected('');
                        }

                        const errors = errorList.filter(
                          (error) => error.field !== 'allAdjustment'
                        );
                        setErrorList([...errors]);

                        const elem = document.getElementById('abc11');
                        if (elem && scrollDownManufacturers) {
                          await Promise.resolve();
                          // setTimeout(() => {
                            elem.scrollIntoView();
                          // }, 1000);
                        }
                      }}
                    />
                  }
                  label="All Adjustments"
                />
              </div>
            </div>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="btn-wrapper col-12">
                <Button
                  onClick={handleSearchClick}
                  className="btn btn-success btn-search float-right"
                >
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="row" id="abc11">
        {!isAllAdjustmentSelected && (
          <div className="col-12 unallocated">
            <TableGridWithFeatures
              onSelectionChanged={onSelectionChanged}
              cellClickedListener={cellClickedListener}
              selectRowIndex={selectedRowIndexValue}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              columnDefs={AllAdjustmentGrid}
              rowData={allAdjustmentList}
              data-testid="onEditingStopped"
              enterMovesDown
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              rowSelection="multiple"
              rowMultiSelectWithClick
              hideTotalCount={false}
              exportFile
              fileName="Adjustments By Reason Code"
            />
          </div>
        )}
      </div>
    </div>
  );
}
